// extracted by mini-css-extract-plugin
export default {"text":"TextView_text__y9Wo5"};